<form class="solicitacao">
  @if (identificado()) {
    <section class="solicitacao-cartao" [attr.data-aberta]="dadosPessoaisAberto()">
      <h2 class="solicitacao-cartao-cabecalho">
        <button
          type="button"
          class="solicitacao-cartao-botao"
          [attr.aria-expanded]="dadosPessoaisAberto()"
          aria-controls="solicitacao-dados-pessoais"
          (click)="alternarDadosPessoais()"
        >
          <span class="solicitacao-cartao-titulo">
            <i-lucide name="user" size="16" aria-hidden="true"></i-lucide>
            Dados pessoais
          </span>

          <i-lucide
            class="solicitacao-cartao-seta"
            [name]="dadosPessoaisAberto() ? 'chevron-up' : 'chevron-down'"
            size="18"
            aria-hidden="true"
          ></i-lucide>
        </button>
      </h2>

      @if (dadosPessoaisAberto()) {
        <div class="solicitacao-corpo" id="solicitacao-dados-pessoais">
          <p class="solicitacao-aviso-dados">
            <i-lucide name="lock" size="16" aria-hidden="true"></i-lucide>
            <span>
              Dados do seu cadastro no portal, exibidos apenas para conferência. Para alterá-los, acesse
              <a class="solicitacao-link" routerLink="/area-cidadao" [queryParams]="{ aba: 'dados' }">
                Área do cidadão {{ ' > ' }} Dados pessoais
              </a>.
            </span>
          </p>

          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-nome">Nome completo</label>
            <input
              id="solicitacao-nome"
              class="solicitacao-input"
              type="text"
              readonly
              [value]="dadosPessoais().nomeCompleto"
            />
          </div>

          <div class="solicitacao-linha solicitacao-linha-local">
            <div class="solicitacao-campo">
              <label class="solicitacao-rotulo" for="solicitacao-cpf">CPF</label>
              <input
                id="solicitacao-cpf"
                class="solicitacao-input"
                type="text"
                readonly
                [value]="dadosPessoais().cpf"
              />
            </div>

            <div class="solicitacao-campo">
              <label class="solicitacao-rotulo" for="solicitacao-telefone">Telefone</label>
              <input
                id="solicitacao-telefone"
                class="solicitacao-input"
                type="text"
                readonly
                [value]="dadosPessoais().telefone"
              />
            </div>
          </div>

          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-email">E-mail</label>
            <input
              id="solicitacao-email"
              class="solicitacao-input"
              type="text"
              readonly
              [value]="dadosPessoais().email"
            />
          </div>
        </div>
      }
    </section>
  }

  @if (store.erroEnvio(); as erro) {
    @if (erro.tipo === 'vaga' || erro.tipo === 'formulario') {
      <p class="solicitacao-aviso" role="alert">
        <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
        {{ erro.mensagem }}
      </p>
    }
  }

  @if (store.carregandoFormulario()) {
    <p class="solicitacao-estado" role="status" aria-live="polite">
      <i-lucide name="loader-circle" size="18" aria-hidden="true"></i-lucide>
      Carregando o formulário deste serviço...
    </p>
  } @else if (store.falhouFormulario()) {
    <div class="solicitacao-estado solicitacao-estado-falha" role="alert">
      <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
      <span>Não foi possível carregar o formulário deste serviço.</span>
      <button type="button" class="solicitacao-estado-botao" (click)="recarregarFormulario()">Tentar novamente</button>
    </div>
  } @else if (!store.formulario()) {
    <p class="solicitacao-estado" role="status">
      <i-lucide name="info" size="18" aria-hidden="true"></i-lucide>
      A solicitação on-line deste serviço não está disponível.
    </p>
  } @else if (store.bloqueioSolicitacao(); as bloqueio) {
    <p class="solicitacao-estado" role="status">
      <i-lucide name="info" size="18" aria-hidden="true"></i-lucide>
      {{ bloqueio }}
    </p>
  } @else {
  @if (store.permiteSegundaVia()) {
    <section class="solicitacao-cartao">
      <fieldset class="solicitacao-via">
        <legend class="solicitacao-cartao-titulo solicitacao-via-titulo">
          <i-lucide name="files" size="16" aria-hidden="true"></i-lucide>
          Tipo do pedido <span class="solicitacao-obrigatorio" aria-hidden="true">*</span>
        </legend>

        <div class="solicitacao-via-opcoes">
          <label class="solicitacao-via-opcao">
            <input type="radio" name="solicitacao-via" [checked]="!store.segundaVia()" (change)="escolherVia(false)" />
            Primeira solicitação
          </label>

          <label class="solicitacao-via-opcao">
            <input type="radio" name="solicitacao-via" [checked]="store.segundaVia()" (change)="escolherVia(true)" />
            Segunda via (reemissão de documento já emitido)
          </label>
        </div>
      </fieldset>
    </section>
  }

  <section class="solicitacao-cartao" [attr.data-aberta]="enderecoAberto()">
    <h2 class="solicitacao-cartao-cabecalho">
      <button
        type="button"
        class="solicitacao-cartao-botao"
        [attr.aria-expanded]="enderecoAberto()"
        aria-controls="solicitacao-endereco"
        (click)="alternarEndereco()"
      >
        <span class="solicitacao-cartao-titulo">
          <i-lucide name="circle-help" size="16" aria-hidden="true"></i-lucide>
          Endereço da solicitação
        </span>

        <i-lucide
          class="solicitacao-cartao-seta"
          [name]="enderecoAberto() ? 'chevron-up' : 'chevron-down'"
          size="18"
          aria-hidden="true"
        ></i-lucide>
      </button>
    </h2>

    @if (enderecoAberto()) {
      <div class="solicitacao-corpo" id="solicitacao-endereco">
        @if (mostrarPendencias() && !store.validoSolicitacao()) {
          <p class="solicitacao-aviso" role="alert">
            <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
            Preencha os campos obrigatórios destacados para avançar.
          </p>
        }

        <div class="solicitacao-linha solicitacao-linha-endereco">
          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-endereco-completo">Endereço completo *</label>
            <input
              id="solicitacao-endereco-completo"
              class="solicitacao-input"
              type="text"
              autocomplete="street-address"
              placeholder="Ex: Rua, Avenida, Travessa..."
              [formField]="solicitacaoForm.endereco"
            />
            @if (solicitacaoForm.endereco().touched() && solicitacaoForm.endereco().invalid()) {
              <p class="solicitacao-erro">Campo obrigatório.</p>
            }
          </div>
          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-numero">Número *</label>
            <input
              id="solicitacao-numero"
              class="solicitacao-input"
              type="text"
              inputmode="numeric"
              placeholder="Ex: 123"
              [formField]="solicitacaoForm.numero"
            />
            @if (solicitacaoForm.numero().touched() && solicitacaoForm.numero().invalid()) {
              <p class="solicitacao-erro">Campo obrigatório.</p>
            }
          </div>
        </div>

        <div class="solicitacao-linha solicitacao-linha-complemento">
          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-complemento">Complemento</label>
            <input
              id="solicitacao-complemento"
              class="solicitacao-input"
              type="text"
              placeholder="Ex: Bloco, apto, sala..."
              [formField]="solicitacaoForm.complemento"
            />
          </div>
          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-cep">CEP *</label>
            <input
              id="solicitacao-cep"
              class="solicitacao-input"
              type="text"
              inputmode="numeric"
              autocomplete="postal-code"
              placeholder="Ex: 00000-000"
              mask="00000-000"
              [formField]="solicitacaoForm.cep"
            />
            @if (solicitacaoForm.cep().touched() && solicitacaoForm.cep().invalid()) {
              <p class="solicitacao-erro">{{ solicitacaoForm.cep().errors()[0]?.message ?? 'Campo obrigatório.' }}</p>
            }
          </div>
          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-bairro">Bairro *</label>
            <input
              id="solicitacao-bairro"
              class="solicitacao-input"
              type="text"
              placeholder="Ex: Centro"
              [formField]="solicitacaoForm.bairro"
            />
            @if (solicitacaoForm.bairro().touched() && solicitacaoForm.bairro().invalid()) {
              <p class="solicitacao-erro">Campo obrigatório.</p>
            }
          </div>
        </div>

        <div class="solicitacao-linha solicitacao-linha-local">
          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-estado">Estado *</label>
            <select
              id="solicitacao-estado"
              class="solicitacao-input"
              autocomplete="address-level1"
              [formField]="solicitacaoForm.uf"
            >
              <option value="">Selecione a UF</option>
              @for (uf of ufs; track uf) {
                <option [value]="uf">{{ uf }}</option>
              }
            </select>
            @if (solicitacaoForm.uf().touched() && solicitacaoForm.uf().invalid()) {
              <p class="solicitacao-erro">Campo obrigatório.</p>
            }
          </div>
          <div class="solicitacao-campo">
            <label class="solicitacao-rotulo" for="solicitacao-cidade">Cidade *</label>
            <input
              id="solicitacao-cidade"
              class="solicitacao-input"
              type="text"
              autocomplete="address-level2"
              placeholder="Ex: Salvador"
              [formField]="solicitacaoForm.cidade"
            />
            @if (solicitacaoForm.cidade().touched() && solicitacaoForm.cidade().invalid()) {
              <p class="solicitacao-erro">Campo obrigatório.</p>
            }
          </div>
        </div>

        <div class="solicitacao-especificos">
          <h3 class="solicitacao-especificos-titulo">Campos específicos</h3>
          <p class="solicitacao-especificos-texto">
            Os campos indicados com asterisco (*) são de preenchimento obrigatório.
          </p>
        </div>

        @for (campo of store.campos(); track campo.codCampoServicoCps) {
          <app-campo-solicitacao [campo]="campo" [mostrarPendencias]="mostrarPendencias()"></app-campo-solicitacao>
        }

        <div class="solicitacao-campo">
          <label class="solicitacao-rotulo" for="solicitacao-descricao">
            Descrição <span class="solicitacao-obrigatorio" aria-hidden="true">*</span>
          </label>
          <textarea
            id="solicitacao-descricao"
            class="solicitacao-input solicitacao-textarea"
            rows="5"
            placeholder="Descreva a solicitação..."
            [formField]="solicitacaoForm.descricao"
          ></textarea>
          <p class="solicitacao-contador" aria-live="polite">
            {{ caracteresDescricao() }}/{{ limiteDescricao }}
          </p>

          @if (solicitacaoForm.descricao().touched() && solicitacaoForm.descricao().invalid()) {
            <p class="solicitacao-erro">{{ solicitacaoForm.descricao().errors()[0]?.message ?? 'Campo obrigatório.' }}</p>
          }
        </div>

        @if (store.agendaIndisponivel()) {
          <p class="solicitacao-aviso" role="alert">
            <i-lucide name="calendar-x" size="18" aria-hidden="true"></i-lucide>
            O agendamento deste serviço ainda não está disponível pelo portal.
          </p>
        } @else if (store.exigeAgendamento()) {
        <div class="solicitacao-campo" role="group" aria-labelledby="solicitacao-agendamento-rotulo">
          <span class="solicitacao-rotulo" id="solicitacao-agendamento-rotulo">
            Data e hora do atendimento <span class="solicitacao-obrigatorio" aria-hidden="true">*</span>
          </span>

          <div class="solicitacao-agendamento">
            @if (store.agendamento(); as escolha) {
              <div class="solicitacao-agendado">
                <span class="solicitacao-agendado-selo" aria-hidden="true">
                  <i-lucide name="calendar-check" size="22"></i-lucide>
                </span>

                <div class="solicitacao-agendado-corpo">
                  <span class="solicitacao-agendado-rotulo">Atendimento agendado</span>
                  <strong class="solicitacao-agendado-valor">
                    {{ agendamentoFormatado() }} às {{ escolha.horario }}
                  </strong>
                </div>

                <div class="solicitacao-agendado-acoes">
                  <button type="button" class="solicitacao-agendado-botao" (click)="abrirAgendamento()">
                    <i-lucide name="pencil" size="14" aria-hidden="true"></i-lucide>
                    Alterar
                  </button>

                  <button
                    type="button"
                    class="solicitacao-agendado-botao solicitacao-agendado-remover"
                    (click)="removerAgendamento()"
                  >
                    <i-lucide name="trash-2" size="14" aria-hidden="true"></i-lucide>
                    Remover
                  </button>
                </div>
              </div>
            } @else {
              <button
                type="button"
                class="solicitacao-agendar"
                [attr.aria-describedby]="agendamentoPendente() ? 'solicitacao-agendamento-erro' : null"
                (click)="abrirAgendamento()"
              >
                <i-lucide name="calendar" size="16" aria-hidden="true"></i-lucide>
                Agendar data e hora
              </button>
            }
          </div>

          @if (agendamentoPendente()) {
            <p class="solicitacao-erro" id="solicitacao-agendamento-erro">Escolha a data e o horário do atendimento.</p>
          }
        </div>
        }
      </div>
    }
  </section>

  }

  <app-modal-agendamento [codServico]="codServico()" (confirmado)="aoAgendar($event)"></app-modal-agendamento>

  <!-- Invisível para quem usa a tela; o robô que lê o HTML preenche (anti-abuso). -->
  <app-campo-honeypot [(valor)]="store.desafio.honeypot" />
</form>
